import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-customer-apk',
  templateUrl: './delete-customer-apk.component.html',
  styleUrls: ['./delete-customer-apk.component.css']
})
export class DeleteCustomerAPKComponent implements OnInit {

  allCustomer: any= []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  cid:any
  CustomerAPKId:any = ""


  constructor(private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllCustomerAPK()
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllCustomerAPK();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllCustomerAPK();
  }

  getAllCustomerAPK(){
    this.generic_service.getAllCustomerAPK().subscribe(
      (response:any)=>{
        console.log(response)
        this.allCustomer = response.response
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton2")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  del(id:any){
    this.CustomerAPKId = id;
  }

  deleteCustomerAPK(){
    this.generic_service.deleteCustomerAPK(this.CustomerAPKId).subscribe(
      (response:any)=>{
        console.log(response);
        this.getAllCustomerAPK()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }



}
